<template>
  <div class="moow-master-container play-background">
    <div v-if="loading" class="m-loader">
      <div class="m-loader-icon-holder">
        <i class="m-loader-icon"></i>
        <p></p>
      </div>
    </div>
    <b-container class="moow-resp-container dashboard-container">
      <property-rep-selector
        :propertyId="selectedPropertyId"
        @setLegalStructure="updateLegalStructure"
        @legalStructureUpdated="updateLegalStructure"
        @structureCreationEngaged="structureCreationEngaged = true"
        @structureEditingCanceled="structureCreationEngaged = false"
      />
      <div class="md-layout">
        <div class="md-layout-item">
          <moow-button
            v-if="enableNextButton"
            :type="['dark', 'outlined', 'flat']"
            btnText="Back"
            @mClick="back"
          />
        </div>
        <div class="md-layout-item" style="text-align:right">
          <moow-button v-if="enableNextButton" :type="['light']" btnText="Next" @mClick="next" />
        </div>
      </div>
      <b-row>
        <b-col></b-col>
      </b-row>
    </b-container>

    <error-snackbar
      :message="errorSnackbarMessage"
      :duration="Number(4000)"
      :showSnackbar="showErrorSnackbar"
      position="center"
      :isInfinity="false"
    ></error-snackbar>
  </div>
</template>

<script>
import PropertyRepSelector from "@/components/property/propertyRepSelector.vue";
import PrivatePersonSearch from "@/components/person/privatePersonSearch.vue";
import JuridicalPersonSearch from "@/components/person/juridicalPersonSearch.vue";
import Snackbar from "@/components/snackbar.vue";
import TenantDetailsForm from "@/components/bookings/tenantForm.vue";
import { filterListingsBasedOn } from "@/searchFunctions.js";
import contractTemplateValues from "@/config/contract_template_values.json";
import {
  idCodeTo_DDMonthYYYY,
  idCodeToDate,
} from "@/utils/other/services/identityService.js";
import { formatTimeToMonthDDYY, formatTimeToDDMMYY } from "@/timeFunctions";
import { upsertPropertyRepresentatives } from "../../../platform/properties/services/propertyService";

export default {
  props: ["comingFromRouteName", "property"],
  components: {
    "error-snackbar": Snackbar,
    "private-person-search": PrivatePersonSearch,
    "juridical-person-search": JuridicalPersonSearch,
    "property-rep-selector": PropertyRepSelector,
  },
  data() {
    return {
      loading: false,
      showErrorSnackbar: false,
      errorSnackbarMessage: "",
      structureCreationEngaged: false,
    };
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  watch: {},
  computed: {
    enableNextButton() {
      if (this.$store.getters.lessor.ownerPersonId) return true;
      else return false;
    },
    selectedPropertyId() {
      return this.$store.getters.property._id;
    },
    defaultConnectedAccountId() {
      return this.$store.getters.connectedAccountIds[0];
    },
  },
  mounted() {},
  created() {},
  methods: {
    updateLegalStructure(legalStructure) {
      if (!legalStructure) {
        return;
      }
      if (this.structureCreationEngaged) {
          upsertPropertyRepresentatives(legalStructure);
      }
      const lsTransformed = {
          ownerPersonType: legalStructure.ownerPersonType,
          ownerPersonId: legalStructure.ownerPersonId,
          repPrivPersonId: legalStructure.repPrivPersonId,
          repJurPersonId: legalStructure.repJurPersonId,
          ownerEmail: legalStructure.ownerEmail,
          ownerAddress: legalStructure.ownerAddress,
          repEmail: legalStructure.repEmail,
          repAddress: legalStructure.repAddress,
      };
      this.$store.commit("DA_SET_LESSOR", lsTransformed);
      this.$store.commit(
          "DA_SET_LESSOR_ACCOUNT_ID",
          this.defaultConnectedAccountId
      );
    },
    back() {
      var name;
      this.comingFromRouteName
        ? (name = this.comingFromRouteName)
        : (name = "dashboard");

      if (name == "manage") {
        var params = {
          listing: this.property,
        };
      }
      this.changeView(name, params);
    },
    next() {
      if (this.$store.getters.lessor.ownerPersonId) {
        this.changeView("dealApplicationTerms");
      } else {
        this.showSnackbar("Missing required details");
      }
    },
    changeView(name, params) {
      this.$router.push({
        name: name,
        params: params,
      });
    },
    showSnackbar(msg) {
      this.showErrorSnackbar = true;
      this.errorSnackbarMessage = msg;
    },
    hideSnackbar() {
      this.showErrorSnackbar = false;
      this.errorSnackbarMessage = "";
    },
  },
};
</script>
<style scoped>
@import "../../../assets/styles/booking.css";
@import "../../../assets/styles/dashboard.css";
@import "../../../assets/styles/global.css";
</style>



// WEBPACK FOOTER //
// src/components/bookings/deals/DealApplicationLessor.vue